<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_exam") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.instructions_ar')"
            v-model.trim="data.instructions_ar"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.instructions_en')"
            v-model.trim="data.instructions_en"
            required
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.min_exam_pass_score')"
            v-model.trim="data.min_passing_score"
            required
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.exam_duration')"
            v-model.trim="data.duration"
            required
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>
<script>
import moment from "moment";
import FileUpload from "../../../components/formInputs/FileUpload.vue";

export default {
  name: "CreateBanks",
  components: { FileUpload },

  data() {
    return {
      isWaitingRequest: false,
      data: {
        name_ar: null,
        name_en: null,
        instructions_ar: null,
        instructions_en: null,
        min_passing_score: "",
        duration: null,
      

},
      // End:: Data Collection To Send
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  methods: {
    handleFileSelect(files) {
      this.selectedFiles = files;
    },
    handleFileRemove(index) {
      this.existingFiles.splice(index, 1);
    },
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    handleFileSelected({ file, fileType }) {
      this.file = file;
      this.fileType = fileType;
    },
    handleFileRemoved() {
      this.file = null;
      this.fileType = "";
    },

    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("type", "placement_Exam");

      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_en) {
        REQUEST_DATA.append("name[en]", this.data.name_en);
      }
      if (this.data.duration) {
        REQUEST_DATA.append("duration", this.data.duration);
      }
      if (this.data.min_passing_score) {
        REQUEST_DATA.append(
          "minimum_passing_score",
          this.data.min_passing_score
        );
      }
      if (this.data.instructions_ar) {
        REQUEST_DATA.append("directions[ar]", this.data.instructions_ar);
      }
      if (this.data.instructions_en) {
        REQUEST_DATA.append("directions[en]", this.data.instructions_en);
      }

      try {
        await this.$axios({
          method: "POST",
          url: `placement-exams`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/placement-exam/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
  },
};
</script>
<style>
.type-selector {
  font-family: "Cairo", sans-serif;
  margin: auto;
  padding: 0px 8px;
  gap: 4px;
  display: flex;
}

.custom-radio {
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 2px solid #ccc;
  padding: 10px 15px;
  margin-bottom: 10px;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
  user-select: none;
}
.custom-radio.disabled {
  cursor: not-allowed !important;
  opacity: 0.6;
  pointer-events: none;
}

.custom-radio input[type="radio"] {
  display: none;
}
.custom-radio input[type="radio"]:disabled {
  cursor: not-allowed !important;
}

.custom-radio .radio-label {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.custom-radio.selected {
  border-color: #0b7477;
  background-color: #e6f8f8;
}

.custom-radio.selected .radio-label {
  color: #0b7477;
}

.selected-type {
  margin-top: 20px;
  font-size: 16px;
  color: #444;
}
</style>
